import React from 'react';
import Hero from './components/Hero';
import ProblemStatement from './components/ProblemStatement';
import SolutionOverview from './components/SolutionOverview';
import KeyFeatures from './components/KeyFeatures';
import SocialProof from './components/SocialProof';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
export function App() {
  return <div className="font-sans bg-[#F7F3E9] text-[#36454F] w-full min-h-screen" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemStatement data-id="element-4" />
        <SolutionOverview data-id="element-5" />
        <KeyFeatures data-id="element-6" />
        <SocialProof data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Pricing data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}